export enum TransactionType {
  Contractual = 0, // قراردادی
  Systemic = 1, // سیستمی
  Manual = 2, // دستی
}

export const ListofTransactionType = [
  { label: "قراردادی", value: 0 },
  { label: "سیستمی", value: 1 },
  { label: "دستی", value: 2 },
];
